import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { selectRoom } from "src/store/rooms/roomsSlice"
import Home from "./sections/Home"

function VentaEnLinea(): JSX.Element {
    const { isRoomDetailsDrawerOpen } = useSelector((state: RootState) => state.navigation)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isRoomDetailsDrawerOpen) {
            // Si mientras tanto se abrió otra habitación, no se limpia la selección
            setTimeout(() => {
                dispatch(((dispatchLater: any, getState: () => RootState) => {
                    if (getState().navigation.isRoomDetailsDrawerOpen) {
                        return
                    }
                    dispatchLater(selectRoom({}))
                }) as any)
            }, 500)
        }
    }, [isRoomDetailsDrawerOpen])

    return <Home />
}

export default VentaEnLinea
